import styled from "styled-components";
import Dialog from "../../../../components/dialog/dialog";
import { COLOUR_CONSTANT } from "../../../../utils/contants";

export const TimesheetNotesModalStyled = styled(Dialog)`
  width: 55%;
  /* height: 80%; */
  .MuiTypography-root {
    color: #301d35 !important;
  }
  .div-1 {
    padding: 16px;
    row-gap: 16px;
    background-color: ${COLOUR_CONSTANT?.theme.purple.light};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-bottom: 1px solid ${COLOUR_CONSTANT?.theme.purple.medium};

    .info {
      display: grid;
      grid-template-columns: 50% 50%;
      .internal {
        display: flex;
        gap: 8px;

        .content {
          flex: 1;
          min-width: 0; /* allow flex-shrink */
          white-space: nowrap; /* no wrapping */
          overflow: hidden; /* hide overflow */
          text-overflow: ellipsis;
        }
      }
      .date {
        display: flex;
        justify-self: flex-end;
      }
    }
  }
  .div-2 {
    > div {
      margin: 0px;
    }

    .MuiInputBase-root {
      padding-bottom: 22px;
    }
  }
  .div-3 {
    background-color: ${COLOUR_CONSTANT?.theme.purple.light};
    border-bottom: 1px solid ${COLOUR_CONSTANT?.theme.purple.medium};

    input {
      border: 0px !important;
      width: 50px !important;
      height: 2px !important;
      text-align: center;
      color: #545f71;
      font-weight: bold;
    }
    .MuiOutlinedInput-notchedOutline {
      border: none;
    }
    .footer {
      display: grid;
      grid-template-columns: 50% 50%;
      padding: 16px;
      .info {
        display: grid;
        grid-template-columns: 50% 50%;
        gap: 8px;
        .content {
          width: auto !important;
        }
      }
      .actions {
        display: flex;
        gap: 15px;
        align-items: end;
        justify-content: flex-end;
      }
    }
  }
`;
